<template>
  <div>
    <div class="card" v-if="local_attrs.length == 0">
      <div class="card-body">
        <p>
          <span>{{ 'no_local_attrs' | t }}</span>
        </p>
      </div>
    </div>
    <div class="card mb-2" v-for="(attr, i) in local_attrs">
      <div class="card-body">
        <local-attr :value="attr" @remove="local_attrs.splice(i, 1)"></local-attr>
      </div>
    </div>
    <br />
    <button class="btn btn-primary" @click="addLocalAttr">{{ 'add_local_attr' | t }}</button><br />
  </div>
</template>
<script>
// import Api from "@/store/jsonapi";
import _ from 'lodash';
// import Alerts from "@/utils/alerts";

export default {
  props: { value: Array },
  data: function () {
    return {
      types: [
        'string',
        'textarea',
        'integer',
        'password',
        'boolean',
        'enum',
        'enum_multi_select',
        'image',
        'sender_address',
        'time_of_day'
      ],
      key_locales: [],
      description_locales: [],
      displayLocalAttributes: false
    };
  },
  computed: {
    local_attrs: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    hasLocale: function (translations, key, locale) {
      return (
        _.find(translations, (translation) => translation.attr_key === key && translation.locale === locale) !==
        undefined
      );
    },
    log() {
      console.log(this.$refs);
    },
    addLocalAttr: function (attr) {
      this.local_attrs.push({
        attr_name: '',
        description: '',
        attr_key: '',
        attr_type: 'string',
        category: '',
        priority: 0,
        requirement_type: 'carrier_details',
        local_attr_enums: [],
        local_attr_translations: [
          {
            locale: 'da',
            translation_label: '',
            translation_help_text: ''
          }
        ]
      });
      this.$emit('input', this.local_attrs);
    },
    removeLocalAttr: function (i) {
      this.local_attrs.splice(i, 1);
      this.$emit('input', this.local_attrs);
    },
    removeEnum: function (attrIndex, enumIndex) {
      var enums = this.local_attrs[attrIndex].local_attr_enums;
      enums.splice(enumIndex, 1);
      this.$emit('input', this.local_attrs);
    }
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
